import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SessionItem } from '../Components/SessionItem';
import { getNotSignedInUserSessions } from '../Helpers/getNotSignedInUserSessions';
import { getSignedInUserSessions } from '../Helpers/getSignedInUserSessions';
import { SessionsCard } from '../Layout/SessionsCard';
import { SessionWithId } from '../Models/session';
import { openAlert } from '../Store/AlertSlice';
import { logIntoSession } from '../firebase/Database/LogIntoSession';
import { LogOutOfSession } from '../firebase/Database/LogOutOfSession';
import { sessionsOnValue } from '../firebase/Database/SessionsOnValue';

export const SessionsPage = () => {
    const [sessions, setSessions] = useState<SessionWithId[]>([]);
    const [mySessions, setMySessions] = useState<SessionWithId[]>([]);
    const [notMySessions, setNotMySessions] = useState<SessionWithId[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = sessionsOnValue(setSessions);
        return () => {
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        setMySessions(getSignedInUserSessions(sessions));
        setNotMySessions(getNotSignedInUserSessions(sessions));
    }, [sessions]);

    const logIntoSessionHandler = (session: SessionWithId) => {
        logIntoSession(session)
            .then(() => {
                dispatch(
                    openAlert({
                        displayText: 'Přihlášení proběhlo úspěšně.',
                        severity: 'success',
                    }),
                );
            })
            .catch((error) => {
                dispatch(
                    openAlert({
                        displayText: 'Přihlášení se nepovedlo.',
                        severity: 'error',
                    }),
                );
            });
    };

    const logOutOfSessionHandler = (session: SessionWithId) => {
        LogOutOfSession(session)
            .then(() => {
                dispatch(
                    openAlert({
                        displayText: 'Úspěšné odhlášení z lekce.',
                        severity: 'success',
                    }),
                );
            })
            .catch((error) => {
                dispatch(
                    openAlert({
                        displayText: 'Nepovedlo se odhlásit z lekce.',
                        severity: 'error',
                    }),
                );
            });
    };

    const mySessionComponents = mySessions.map((session) => {
        return (
            <SessionItem
                key={session.id}
                session={session}
                onSessionClick={logOutOfSessionHandler}
                login={false}
            />
        );
    });

    const notMySessionComponents = notMySessions.map((session) => {
        return (
            <SessionItem
                key={session.id}
                session={session}
                onSessionClick={logIntoSessionHandler}
                login={true}
            />
        );
    });

    return (
        <Grid container height="100%" justifyContent="space-evenly">
            <Grid item xs={10} lg={5}>
                <SessionsCard title="Přihlášené lekce">
                    {mySessionComponents}
                </SessionsCard>
            </Grid>
            <Grid item xs={10} lg={5}>
                <div style={{ marginBottom: '50px' }}>
                    <SessionsCard title="Nabízené lekce">
                        {notMySessionComponents}
                    </SessionsCard>
                </div>
            </Grid>
        </Grid>
    );
};
